<template>
  <main-layout>
    <div slot="left-side">
      <menubar screenIdParam="M-06-40"></menubar>
    </div>
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">
          {{ $t("label.system.userGroup.search.title") }}
        </label>
        <lvory-but
          @click="back"
          slot="cancel">
            {{ $t("button.common.data.cancel") }}
        </lvory-but>
        <narrow-down
          v-auth="{ auth: '010702' }"
          slot="create"
          @click="createUserGroup">
          {{$t("button.common.data.create")}}
        </narrow-down>
      </head-title>
    </el-row>
    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{ $t("label.system.userGroup.create.userGroupCreate") }}
      </div>
      <el-row>
        <span class="star-color">* </span>
        <span class="c-ivory01">{{ $t("label.common.must") }}</span>
      </el-row>

      <el-form
        ref="ruleForm"
        class="account-create"
        label-position="left"
        :rules="rules"
        :model="userGroupInfo">
        <div class="info-margin-top">
            <!-- ユーザーグループID -->
            <el-form-item
                class="asterisk line-height-44"
                prop="userGroupExID"
                :label="$t('label.system.userGroup.search.userGroupID')"
                label-width="200px">
                <el-input
                maxlength="20"
                class="new-input-style show-word-limt-input-iot"
                show-word-limit
                v-model="userGroupInfo.userGroupExID"
                :placeholder="$t('label.system.userGroup.search.userGroupID')">
                </el-input>
            </el-form-item>
            <!-- ユーザーグループ名 -->
            <el-form-item
                prop="userGroupName"
                class="asterisk line-height-44"
                :label="$t('label.system.userGroup.search.userGroupName')"
                label-width="200px">
                <el-input
                maxlength="50"
                class="new-input-style show-word-limt-input-iot"
                show-word-limit
                v-model="userGroupInfo.userGroupName"
                :placeholder="$t('label.system.userGroup.search.userGroupName')">
                </el-input>
            </el-form-item>
            <!-- テナント -->
            <el-form-item
                class="asterisk line-height-44"
                prop="tenantName"
                :label="$t('label.system.userGroup.create.tenant')"
                label-width="200px">
                <div class="float-left">
                  <el-input
                      readonly
                      class="new-input-style"
                      v-model="userGroupInfo.tenantName"
                      :placeholder="$t('label.system.account.create.tenantNameSearch')">
                  </el-input>
                </div>
                <select-btn
                    class="selectBtn float-left margin-left-3"
                    @click="searchTenantPopup">
                    {{ $t("button.common.select") }}
                </select-btn>
            </el-form-item>
        </div>

      </el-form>

      <narrow-down
        class="m-left-200 m-bottom-5 m-top-20"
        @click="createUserGroup">
        {{$t("button.common.data.create")}}
      </narrow-down>


      <loading-dialog :dialogVisible="showLoading" />


      <!-- テナント選択子画面 -->
      <tenant-search-popup
        :visible.sync="tenantSearchFlg"
        :includeDeleteDataFlag = false
        @on-selected="getTenantInfo"/>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>
    </div>

  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import MainLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import TenantSearchPopup from "@/components/system/popup/TenantSearchPopup";
import Menubar from "@/components/leftmenu/DashBoard";
import headTitle from "@/components/common/head/head";
import LvoryBut from "@/components/common/generalButton/LvoryBut";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import errorCodeMsg from "@/utils/error-code-msg"
import selectBtn from "@/components/common/generalButton/Select";

export default {
  name: "AccountCreate",
  components: {
    MainLayout: MainLayout,
    TenantSearchPopup: TenantSearchPopup,
    LoadingDialog: LoadingDialog,
    Menubar: Menubar,
    headTitle: headTitle,
    narrowDown: narrowDown,
    elDialogPrompt: elDialogPrompt,
    LvoryBut:LvoryBut,
    selectBtn
  },
  data() {
    return {
      userGroupInfo:{
        userGroupExID:null,
        userGroupName:null,
        tenantId:null,
        tenantExId:null,
        tenantName:null
      },
      showLoading:false,
      tenantSearchFlg:false,
      msgParam: this.$t("message.common.validation.saveMessage",{
        field: this.$t("label.menu.UserGroup")
      }),
      centerDialogVisibleIsShow: false,
      rules:{
        userGroupExID: [
          {
            max: 20,
            trigger: 'change',
            message: this.$t('message.common.validation.telMessageLength', {
              field: this.$t('label.system.userGroup.search.userGroupID'),
              length: 20
            })
          },
          {
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: this.$t('label.system.userGroup.search.userGroupID')
            })
          },
          {
            pattern:  /^[A-Za-z0-9]+$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: this.$t('label.system.userGroup.search.userGroupID'),
              type: '半角英数字'
            })
          }
        ],
        userGroupName: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: this.$t('label.system.userGroup.search.userGroupName')
            })
          },
          {
            max: 50,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t('label.system.userGroup.search.userGroupName'),
              length: 50
            })
          }
        ],
        tenantName:{
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: this.$t('label.system.account.create.tenantNameSearch')
            })
        }
      },
    };
  },
  watch: {

  },
  created() {
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/user-group/search",
        title: "label.menu.UserGroup",
      },
      {
        path: "",
        title: "label.menu.userGroupCreate",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
    if (this.$IsOwnerManager()) {
      this.accountType= [
        {
          value: "02",
          type: this.$t("label.system.account.accountType.BM"),
        },
        {
          value: "04",
          type: this.$t("label.system.account.accountType.tenant"),
        }
      ];
    }
  },
  methods: {

    back() {
      this.$router.push({
        name: "system-user-group-search",
      });
    },

    /**
     *  テナント選択 スプライト
     */
    searchTenantPopup() {
      this.tenantSearchFlg = true;
    },

    /**
     *  テナント選択 スプライト
     */
    getTenantInfo(tenant) {
      this.userGroupInfo.tenantId = tenant.tenantId;
      this.userGroupInfo.tenantExId = tenant.tenantExId;
      this.userGroupInfo.tenantName = tenant.tenantName;
    },


    isPassParam(param){
      if(param){
        this.doneCreateUserGroup();
      }
    },

    /**
     * ユーザーグループ新規登録
     */
    createUserGroup() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.centerDialogVisibleIsShow = true
        }
      });
    },

    /**
     * ユーザーグループ新規登録
     */
    doneCreateUserGroup() {
      this.showLoading = true;
      SystemManageApi.createUserGroup({
        tenantId:this.userGroupInfo.tenantId,
        userGroupExID:this.userGroupInfo.userGroupExID,
        userGroupName:this.userGroupInfo.userGroupName
      })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.saveSuccess();
          this.userGroupId = data.body.userGroupId;
          this.$router.push({
            name: "system-user-group-detail",
            params: {
              userGroupId: this.userGroupId,
            },
          });
        }).finally(()=>{
          this.showLoading = false
        })
    },

    /**
     *登録成功
     */
    saveSuccess() {
      this.$messageIotSuccess(this.$t("message.common.createSuccess", {
        field: this.$t("label.system.userGroup.search.title"),
      }));
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}


::v-deep .new-input-style {
  .el-input__inner{
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}
.star-color {
  color: #e65245
}
.float-left {
  float:left;
}

.info-margin-top {
  margin-top: 40px;
}

.hr {
  height: 1px;
  width: 800px;
  background-color: #D1D1CD;
}
::v-deep .el-form-item__label:before {
  display: none;
}
::v-deep .asterisk {
  .el-form-item__label::after{
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
::v-deep .el-form-item__error {
  width: 800px;
  padding-top: 6px;
}


::v-deep .el-form-item {
  margin-bottom: 40px !important;
}

::v-deep .el-row--flex.is-align-middle {
  align-items: normal;
}


.line-height-44::v-deep {
  .el-form-item__label {
    line-height: 44px !important;
  }
}

.account-create::v-deep {
  .el-form-item__label {
    font-size: 16px;
  }
}

.m-top-20 {
  margin-top: 20px;
}

.m-left-200 {
  margin-left: 200px;
}
</style>
